'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EditorHeader = require('./components/EditorHeader.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditorHeader).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/editor-header/index.js
// module id = 1038
// module chunks = 0